import React from "react";
import "./Experiences.css";
import {Timeline} from "./Timeline/Timeline";
import {its, srm, topstech, upwork} from "../../assets/images";

const Experiences = () => {
  const data = [
    {
      title: "Jan 2021 - Present",
      content: (
        <div className="timeline-content-inner">
          <div className="timeline-content-header">
            <div className="timeline-image-div">
              <div
                className="timeline-image"
                style={{backgroundColor: "#383e56"}}
              >
                <img src={upwork} alt="upwork" />
              </div>
            </div>
            <div className="timeline-designation-area">
              <h3>Full-Stack Developer</h3>
              <p>Upwork Freelancer</p>
            </div>
          </div>
          <div className="timeline-content-paragraphs">
            <ul>
              <li>
                Developing and maintaining web applications using React.js and
                other frameworks and technologies.
              </li>
              <li>
                Collaborating with cross-functional teams including designers,
                product managers, and other developers to create high-quality
                products.
              </li>
              <li>
                Implementing responsive design and ensuring cross-browser
                compatibility.
              </li>
              <li>
                Participating in code reviews and providing constructive
                feedback to other developers.
              </li>
            </ul>
          </div>
        </div>
      ),
    },
    {
      title: "Jan 2020 - Aug 2021",
      content: (
        <div className="timeline-content-inner">
          <div className="timeline-content-header">
            <div className="timeline-image-div">
              <div
                className="timeline-image"
                style={{backgroundColor: "#e6dedd"}}
              >
                <img src={srm} alt="srm" />
              </div>
            </div>
            <div className="timeline-designation-area">
              <h3>iOS & Android App Developer</h3>
              <p>SRM University - Chennai</p>
            </div>
          </div>
          <div className="timeline-content-paragraphs">
            <ul>
              <li>
                From concept to deployment, I'm the wizard turning ideas into
                polished mobile applications.
              </li>
              <li>
                Collaborating seamlessly with diverse teams, I stay on the pulse
                of platform advancements to deliver cutting-edge solutions.
              </li>
              <li>
                In the dynamic world of iOS and Android app development, I craft
                user-centric experiences by blending creativity and code.
              </li>
              <li>
                It's not just development; it's sculpting the future of mobile
                innovation.
              </li>
            </ul>
          </div>
        </div>
      ),
    },
    {
      title: "Fab 2017 - Dec 2019",
      content: (
        <div className="timeline-content-inner">
          <div className="timeline-content-header">
            <div className="timeline-image-div">
              <div
                className="timeline-image"
                style={{backgroundColor: "#383e56"}}
              >
                <img src={topstech} alt="topstech" />
              </div>
            </div>
            <div className="timeline-designation-area">
              <h3>Web/Mobile Apps Developer</h3>
              <p>Top's Technologies</p>
            </div>
          </div>
          <div className="timeline-content-paragraphs">
            <ul>
              <li>
                In the Top's tech company to build Web and Mobile App
                development, I'm the architect behind digital innovations.
              </li>
              <li>
                I thrive on weaving together the fabric of seamless user
                experiences, coding with precision to bring web and mobile
                applications to life.
              </li>
              <li>
                Collaborating seamlessly with diverse teams, I stay at the
                forefront of technology trends, ensuring the delivery of
                cutting-edge and user-friendly digital solutions.
              </li>
              <li>
                It's not just code; it's crafting a dynamic digital landscape.
              </li>
            </ul>
          </div>
        </div>
      ),
    },
    {
      title: "Fab 2017 - Dec 2019",
      content: (
        <div className="timeline-content-inner">
          <div className="timeline-content-header">
            <div className="timeline-image-div">
              <div
                className="timeline-image"
                style={{backgroundColor: "#e6dedd"}}
              >
                <img src={its} alt="its" />
              </div>
            </div>
            <div className="timeline-designation-area">
              <h3>Full stack Developer</h3>
              <p>Ideas To Solution</p>
            </div>
          </div>
          <div className="timeline-content-paragraphs">
            <ul>
              <li>
                As a Full Stack Developer, I navigate both server and
                client-side landscapes, turning concepts into robust web
                applications.
              </li>
              <li>
                My expertise spans front-end interfaces to back-end databases,
                ensuring a seamless user journey.
              </li>
              <li>
                With a knack for problem-solving, I tackle challenges from UI
                design to server optimization.
              </li>
              <li>
                In the ever-evolving tech ecosystem, I'm the architect behind
                comprehensive and efficient digital solutions.
              </li>
            </ul>
          </div>
        </div>
      ),
    },
  ];
  return (
    <section className="section timeline-section">
      <div className="timeline-wrapper">
        <Timeline data={data} />
      </div>
    </section>
  );
};

export default Experiences;
